import { useQuery } from "@apollo/client";
import type { ReadSuperadminMembershipConnection } from "@casey/db-types";
import { READ_SUPERADMIN_MEMBERSHIP_QUERY } from "../gql/index";

export function useReadSuperadminMembership() {
  return useQuery<{
    readSuperadminMembership: ReadSuperadminMembershipConnection;
  }>(READ_SUPERADMIN_MEMBERSHIP_QUERY);
}
